import styled from 'styled-components';

import { CreditType, WalletFragmentFragment } from 'data/__generated__';
import { renderAsPrice } from 'helpers/price';
import { TotemLabel } from 'components/TotemLabel';

export function WalletBalance({ credits }: { credits: WalletFragmentFragment['credits'] }) {
    const totemCashAmount = credits
        .filter((credit) => credit.type === CreditType.Cash)
        .reduce((acc, credit) => acc + credit.currentAmount, 0);

    const otherCreditsAmount = credits
        .filter((credit) => credit.type !== CreditType.Cash)
        .reduce((acc, credit) => acc + credit.currentAmount, 0);

    const total = totemCashAmount + otherCreditsAmount;

    return (
        <Container>
            <Row>
                <TotemLabel>Solde actuel</TotemLabel>
                <Total>{renderAsPrice(total)}</Total>
            </Row>
            <Breakdown>
                <BreakdownItem>
                    <BreakdownLabel>dont Totem Cash</BreakdownLabel>
                    <BreakdownValue>{renderAsPrice(totemCashAmount)}</BreakdownValue>
                </BreakdownItem>
                <BreakdownItem>
                    <BreakdownLabel>dont autres crédits</BreakdownLabel>
                    <BreakdownValue>{renderAsPrice(otherCreditsAmount)}</BreakdownValue>
                </BreakdownItem>
            </Breakdown>
        </Container>
    );
}

const Container = styled.div`
    display: flex;
    flex-direction: column;
    padding: 12px 16px;
    border: 1px solid ${({ theme }) => theme.lightBorderColor};
    border-radius: ${({ theme }) => theme.borderRadius};
    background-color: ${({ theme }) => theme.cardBackgroundColor};
    gap: 8px;
`;

const Row = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: baseline;
`;

const Total = styled.span`
    font-size: 22px;
    font-weight: 600;
    color: ${({ theme }) => theme.textColor};
`;

const Breakdown = styled.div`
    display: flex;
    gap: 24px;
`;

const BreakdownItem = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
`;

const BreakdownLabel = styled.span`
    font-size: 12px;
    color: ${({ theme }) => theme.infoTextColor};
`;

const BreakdownValue = styled.span`
    font-size: 14px;
    color: ${({ theme }) => theme.textColor};
`;
